"use client";
import {Form} from "@/components/ui/form";
import * as yup from "yup";
import {CWFInput} from "@/components/ui/CWFInput";
import CWFButton from "@/components/ui/CWFButton";
import {useForm, useWatch} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import axios from "@/lib/axios";
import {useState} from "react";
import toast from "react-hot-toast";
import {RiCheckboxCircleFill, RiCloseCircleFill} from "react-icons/ri";

const REQUIRED_ERROR = "Ce champ est requis."

const formSchema = yup.object({
    code: yup.number().required(REQUIRED_ERROR),
    password: yup.string()
        .matches(/.*([0-9]|\W).*/, "Votre mot de passe ne respecte pas les prérequis.")
        .required(REQUIRED_ERROR),
    password_confirmation: yup.string()
        .oneOf([yup.ref('password'), null], "La confirmation est différente du mot de passe.")
        .required(REQUIRED_ERROR),
});

function pwdIsLenOk(password){
    return password?.length >= 8;
}

function pwdIsCompOk(password) {
    return password?.match(/.*([0-9]|\W).*/); // /^(?=.*\d)(?=.*[^a-zA-Z0-9]).*$/;
}

function PwdRequirement({ title, valid }) {
    return (
        <li className={`flex items-center gap-2 text-xs ${valid ? "text-green-500" : "text-muted-foreground"} font-semibold`}>
            {valid ? (
                <RiCheckboxCircleFill className="text-green-500 min-w-max" size="15px" />
            ) : (
                <RiCloseCircleFill className="text-muted-foreground min-w-max" size="15px" />
            )}
            {title}
        </li>
    );
}

export default function ForgotPassAction({setForgotPass}){

    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false)
    const [showPass, setShowPass] = useState(false);
    const forgotForm = useForm({
        resolver: yupResolver(formSchema)
    });

    const password = useWatch({ control: forgotForm.control, name: "password" });

    function forgotSubmit(data){
        axios.post('forgot-pass/action', data)
            .then(res => {
                setForgotPass(false);
                toast.success("Votre mot de passe a bien été changé");
            })
            .catch(err => {
                setError(true);
            })
    }

    return (
        <Form {...forgotForm}>
            <form onSubmit={forgotForm.handleSubmit(forgotSubmit)} className="grid gap-4 overflow-y-auto">
                {error && (
                    <p className="rounded-md border border-red-300 bg-red-50 text-red-500 text-center text-sm p-1">
                        Code et/ou mot de passe invalide ou expiré.
                    </p>
                )}
                <CWFInput control={forgotForm.control} name="code" label="Code" type="text" />
                <div>
                    <CWFInput control={forgotForm.control} name="password" label="Mot de passe" type={showPass ? "text" : "password"} withIcon={true} showPass={showPass} setShowPass={setShowPass} />
                    <ul className="mt-3 px-3 grid gap-2">
                        <PwdRequirement title="Fiabilité du mot de passe" valid={pwdIsCompOk(password) && pwdIsLenOk(password)}/>
                        <PwdRequirement title="Au moins 8 caractères" valid={pwdIsLenOk(password)}/>
                        <PwdRequirement title="Contient un chiffre ou un symbole" valid={pwdIsCompOk(password)}/>

                        {/*<li className="flex items-center gap-2 text-xs text-neutre-700 font-semibold"><RiCloseCircleFill className="text-neutre-800 min-w-max" size="15px" />Ne doit pas contenir votre nom ni votre adresse e-mail</li>*/}
                    </ul>
                </div>

                <CWFInput control={forgotForm.control} name="password_confirmation" label="Confirmation mot de passe" type={showPass ? "text" : "password"} withIcon={true} showPass={showPass} setShowPass={setShowPass} />
                <div className={"flex justify-end"}>
                    <p className={"text-sm text-primary underline cursor-pointer"} onClick={() => setForgotPass(false)}>Retour à la connexion</p>
                </div>
                <CWFButton type="submit" loading={loading}>Changer mon mot de passe</CWFButton>
            </form>
        </Form>
    )
}
